import moment from "moment/moment";
import {MONGO_DATE_FORMAT} from "../utils/date";
import {LessonInstanceException} from "../types/LessonInstanceException";

export class LessonInstanceExceptionDecorator {
    private exception: LessonInstanceException;

    constructor(exception: LessonInstanceException) {
        this.exception = {...exception};
    }

    getInstanceDate(): moment.Moment | null {
        const date = moment(this.exception.instance_date, MONGO_DATE_FORMAT, true);
        return date.isValid() ? date : null;
    }
}